import CheckIcon from '@mui/icons-material/Check';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Tooltip } from '@mui/material';
import React from 'react';

interface IVerifiedIconProps {
	isVerified: boolean;
	verifiedTitle: string;
	unverifiedTitle: string;
}

const VerifiedIcon: React.FC<IVerifiedIconProps> = ({
	isVerified,
	verifiedTitle,
	unverifiedTitle
}) => (
	<Tooltip
		title={isVerified ? verifiedTitle : unverifiedTitle}
		data-testid="verified-icon"
	>
		{isVerified ? (
			<CheckIcon
				data-testid="verified-icon"
				color="success"
				fontSize="small"
				transform="scale(0.7)"
			/>
		) : (
			<ErrorOutlineIcon
				data-testid="unverified-icon"
				color="warning"
				fontSize="small"
				transform="scale(0.7)"
			/>
		)}
	</Tooltip>
);

export default VerifiedIcon;
